import clsx from 'clsx';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Agenda } from '@enums';
import { DashboardBarChart } from '../bar-chart';
import { DashboardButton } from '../button';
import { DashboardCard } from '../card';
import { useStyles } from '../dashboard';
import { useFilesStatistics } from '../dashboard-hook';
import { DashboardDivider } from '../divider';

export function EsFilesStatistics() {
  const classes = useStyles();

  const {
    agenda,
    setAgenda,
    statesAccordingToAgendas,
    allFilesAccordingToAgendas,
  } = useFilesStatistics();

  return (
    <>
      <Typography
        variant="subtitle1"
        className={clsx(classes.padded, classes.subtitle)}
      >
        Statistiky spisů
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <DashboardCard>
            <Grid container spacing={3}>
              <Grid item xs={5} style={{ placeSelf: 'center' }}>
                {allFilesAccordingToAgendas?.map((item) => (
                  <DashboardButton
                    key={item.id}
                    label={item.label}
                    value={item.value}
                    active={item.id === agenda}
                    showAction={true}
                    onClick={() => setAgenda(item.id as Agenda)}
                  />
                ))}
              </Grid>
              <Grid item xs={7}>
                <DashboardDivider text="Spisy dle stavů" />
                <DashboardBarChart data={statesAccordingToAgendas[agenda]} />
              </Grid>
            </Grid>
          </DashboardCard>
        </Grid>
      </Grid>
    </>
  );
}
